export default {
  inject: ['load'],
  data() {
    return {
      geoCode: null,
      reverseGeoCode: '',
      address: '',
    };
  },
  methods: {
    getMapGeoCode: function (text) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMapGeoCode', text).then(() => {
        if (this.$store.state.mapModule.successFlag) {
          let temp = this.$store.state.mapModule.geoCode;
          if (this.$route.name == 'dispatchMap' || this.$route.name == 'newMissionWithMap800' || this.$route.name == 'followUpMap' || this.$route.name == 'eocMap') {
            this.goToAddress(temp);
          }
          if (this.$route.name == 'admissionMap') {
            this.goToAddress(temp);
          }
          if (this.formLoad) {
            this.goToAddress(temp);
          }
          if (this.deploymentFormLoad) {
            this.goToAddress(temp);
          }
          if (this.sendTOPhoneModal) {
            this.goToAddress(temp);
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.mapModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMapGeoCode(text);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.mapModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMapGeoCode(text);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          }
        }
      });
    },
    getMapReverseGeoCode: function (data) {
      /*if (!this.load.val) {
                this.load.val = true;
            }*/
      this.$store.dispatch('getMapReverseGeoCode', { lat: data.lat, lng: data.lng }).then(() => {
        if (this.$store.state.mapModule.successFlag) {
          let temp = this.$store.state.mapModule.reverseGeoCode;
          this.address = temp;
          if (this.formLoad) {
            this.setAddress(temp);
            this.changeSetAddressIcon();
          }
          if (this.deploymentFormLoad) {
            this.setAddress(temp);
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.mapModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMapReverseGeoCode(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.mapModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMapReverseGeoCode(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          }
        }
      });
    },
    showError: function () {
      const snackText = this.$store.state.mapModule.error;
      this.showErrorAlert(snackText);
    },
  },
};
